import { render } from "./OverallPerformance.vue?vue&type=template&id=276a48da&scoped=true"
import script from "./OverallPerformance.vue?vue&type=script&lang=js"
export * from "./OverallPerformance.vue?vue&type=script&lang=js"

import "./OverallPerformance.vue?vue&type=style&index=0&id=276a48da&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276a48da"]])

export default __exports__